const t = {
  name: "CashStack",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4ZM10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8Z" fill="currentColor"/>
<path d="M22 1H2V15H22V1ZM4 13V3H20V13H4Z" fill="currentColor"/>
<path d="M22 17V19H2V17H22Z" fill="currentColor"/>
<path d="M22 23V21H2V23H22Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as CashStack
};
